<template>
	<article class="news-content">
		<p class="news-content__date">{{ format(new Date(newsForm.date), 'dd.MM.yyyy') }}</p>
		<h1 class="news-content__title">{{ newsForm.title }}</h1>
		<ul v-if="newsForm.categories && newsForm.categories.length > 0" class="news-content__categories">
			<li v-for="category in newsForm.categories" :key="category.id" class="news-content__category">
				<nuxt-link :to="localePath({ name: 'blog-newsTitle', params: { newsTitle: [category.slug] } })" class="news-content__category-link">{{
					category.name
				}}</nuxt-link>
			</li>
		</ul>
		<div class="news-content__content">
			<div
				v-if="edit && newsForm.topImage && newsForm.topImage?.imagePreview && !newsForm.topImage?.image?.createdAt"
				class="news-content__top-image-container">
				<GlobalImage class="news-content__top-image" :src="newsForm.topImage?.imagePreview" :height="308" :alt="newsForm?.title" />
			</div>
			<div v-else-if="newsForm.topImage && newsForm.topImage?.path" class="news-content__top-image-container">
				<GlobalImage class="news-content__top-image" :src="storageUrl + newsForm.topImage?.path" :height="308" :alt="newsForm.title" />
			</div>
			<div v-else-if="newsForm.topImage && newsForm.topImage?.imagePreview" class="news-content__top-image-container">
				<GlobalImage
					class="news-content__top-image"
					:src="storageUrl + newsForm.topImage?.imagePreview"
					:height="308"
					:alt="newsForm.title" />
			</div>

			<div v-if="newsForm.content" class="news-content__text rich-text">
				<template v-for="(node, index) in parsedContent" :key="index">
					<GlobalImage v-if="node.type === 'image'" :src="node.src || ''" :alt="node.alt || ''" quality="95" />
					<div v-else v-html="node.content"></div>
				</template>
			</div>
			<!-- <div
				v-if="edit && newsForm.bottomImage && newsForm.bottomImage?.imagePreview && !newsForm.bottomImage?.image?.createdAt"
				class="news-content__bottom-image-container">
				<GlobalImage class="news-content__bottom-image" :src="newsForm.bottomImage?.imagePreview" :height="308" />
			</div>
			<div v-else-if="newsForm.bottomImage && newsForm.bottomImage?.path" class="news-content__bottom-image-container">
				<GlobalImage
					class="news-content__bottom-image"
					:src="storageUrl + newsForm.bottomImage?.path"
					:height="308"
					:alt="newsForm.bottomImage?.name ?? ''" />
			</div>
			<div v-else-if="newsForm.bottomImage && newsForm.bottomImage?.imagePreview" class="news-content__top-image-container">
				<GlobalImage
					class="news-content__top-image"
					:src="storageUrl + newsForm.bottomImage?.imagePreview"
					:height="308"
					:alt="newsForm.bottomImage?.name ?? ''" />
			</div> -->
		</div>
	</article>
</template>

<script setup lang="ts">
import { format } from 'date-fns'

const { storageUrl } = useStorageService()
const localePath = useLocalePath()

const props = defineProps<{
	edit?: boolean
	newsForm: {
		date: Date
		title: string
		content: string
		topImage: unknown
		bottomImage: unknown
		categories?: INewsCategoryModel[]
	}
}>()

const parsedContent = computed(() => {
	if (!props.newsForm.content || typeof props.newsForm.content !== 'string') return []

	const content = props.newsForm.content as string
	const nodes: Array<{ type: string; content?: string; src?: string; alt?: string }> = []

	const imgRegex = /<img[^>]+src="([^"]+)"[^>]*alt="([^"]*)"[^>]*>/g
	let match

	let lastIndex = 0

	while ((match = imgRegex.exec(content)) !== null) {
		if (match.index > lastIndex) {
			nodes.push({
				type: 'text',
				content: content.slice(lastIndex, match.index),
			})
		}

		nodes.push({
			type: 'image',
			src: match[1],
			alt: match[2],
		})

		lastIndex = match.index + match[0].length
	}

	if (lastIndex < content.length) {
		nodes.push({
			type: 'text',
			content: content.slice(lastIndex),
		})
	}

	return nodes
})
</script>

<style lang="scss" scoped src="./Content.scss"></style>
